import { motion } from "framer-motion";
import {FounderImg} from "@/assets/img/imageAssets"; // Update path as needed

export default function EtAboutFounder() {

  // First Created - 23 Nov 2025
  // Author - Atul Pandey
  // Purpose — About Et Founder
  // Updated — 24 Nov 2025 - Copy Refinement

  return (
    <section className="relative overflow-hidden py-28 bg-black text-white">

      {/* --- Background: deep warm gradient --- */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-orange-900/10"></div>

      {/* Radial warm halo */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_60%,rgba(255,125,10,0.08),transparent_70%)]"></div>

      {/* Light warm noise layer */}
      <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/asfalt-light.png')]"></div>

        {/* <motion.h2
            className="text-center text-3xl md:text-4xl font-bold text-orange-500 mb-14 drop-shadow-[0_0_20px_rgba(255,125,0,0.3)]"
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 1.2 }}
        >
            About the Founder
        </motion.h2> */}

      {/* <div className="relative z-20 max-w-6xl mx-auto px-8 grid md:grid-cols-2 gap-16 items-center"> */}
      <div className="relative z-20 max-w-6xl mx-auto px-8 grid md:grid-cols-[1fr_1.4fr] gap-16 items-center">

        

        {/* Founder image with warm glow */}
        <motion.div
          initial={{ opacity: 0, x: -25 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="relative"
        >
          <div className="absolute inset-0 bg-orange-600/20 blur-[90px] rounded-2xl"></div>

          <img
            src={FounderImg}
            alt="Founder"
            className="relative z-10 rounded-2xl shadow-[0_0_40px_rgba(255,125,0,0.15)] object-cover"
          />
        </motion.div>

        {/* Text Block */}
        <motion.div
          initial={{ opacity: 0, x: 25 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="space-y-6 max-w"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-orange-500 drop-shadow-[0_0_20px_rgba(255,125,0,0.3)]">
            About the Founder
          </h2>

          {/* 24 Nov 2025 - Copy */}
          <p className="text-gray-300 leading-relaxed text-lg font-extralight">
            Atul Pandey is the Founder & CEO of 
            <span className="text-orange-600 font-semibold"> Eternity Solutions Corp</span>.  
            A builder of leaders, organizations, and growth engines across the tech-services world.
            </p>

            <p className="text-gray-300 leading-relaxed text-lg font-extralight">
            His three-decade journey began at 
            <span className="text-orange-600 font-semibold"> Tata Motors</span>, followed by nearly 
            twenty years at <span className="text-orange-600 font-semibold"> Infosys</span> and 
            <span className="text-orange-600 font-semibold"> Cognizant</span>, where he worked across 
            sales, delivery, consulting, and growth incubation.  
            He has partnered with <span className="text-orange-600 font-semibold">Fortune 500</span> and 
            <span className="text-orange-600 font-semibold"> Global 2000</span> clients across manufacturing, 
            high-tech, retail, banking, and emerging tech.
            </p>

            <p className="text-gray-300 leading-relaxed text-lg font-extralight">
            He is also the author of 
            <span className="text-orange-600 font-semibold"> “Realize the Possible”</span>, 
            a book on human potential, clarity, and purposeful growth.
            </p>

            <p className="text-gray-300 leading-relaxed text-lg font-extralight">
            <span className="text-orange-600 font-semibold">Eternity</span> and 
            <span className="text-orange-600 font-semibold"> Trinity</span> were born from these lived 
            experiences — the understanding that meaningful growth requires 
            <span className="text-orange-600 font-semibold"> clarity</span>, 
            <span className="text-orange-600 font-semibold"> purpose</span>, and 
            <span className="text-orange-600 font-semibold"> consistent execution</span>.  
            His work blends deep industry wisdom with structured thinking to help leaders amplify 
            who they are and what they can create.
            </p>

            <p className="text-gray-300 leading-relaxed text-lg font-extralight italic">
            “At the heart of every transformation is a leader who chooses to grow.”
            </p>


          {/* <p className="text-gray-300 leading-relaxed text-lg font-extralight">
            Atul Pandey is the Founder & CEO of Eternity Solutions Corp.  
            A builder of leaders, organizations, and growth engines across the tech-services world.
          </p>

          <p className="text-gray-300 leading-relaxed text-lg font-extralight">
            With a career shaped at <span className="text-orange-600 font-semibold">Infosys</span>, 
            <span className="text-orange-600 font-semibold"> Cognizant</span>, and leading 
            tech-services firms, he has partnered with hundreds of CxOs and business leaders — 
            helping them rethink growth, leadership, and client impact.
          </p>

          <p className="text-gray-300 leading-relaxed text-lg font-extralight">
            Eternity and Trinity were born from decades of real-world experience — the belief 
            that meaningful growth requires <span className="text-orange-600 font-semibold">clarity</span>, 
            <span className="text-orange-600 font-semibold"> purpose</span>, and 
            <span className="text-orange-600 font-semibold"> consistent execution</span>.  
            His work blends deep industry wisdom with structured thinking to help leaders amplify who they are and what they can create.
          </p>

          <p className="text-gray-300 leading-relaxed text-lg font-extralight italic">
            “At the heart of every transformation is a leader who chooses to grow.”  
          </p> */}
        </motion.div>
      </div>
    </section>
  );
}